module.exports = __webpack_public_path__ + "static/media/issue5.f8df7dc5.webp";